import 'reflect-metadata';
import { jsonProperty, Serializable } from 'ts-serializable';

import { FixedTypeModel } from '~modules/fileTypes/models/FixedTypeModel';

import { FileExtTypeEnum } from '../types/FileExtTypeEnum';

export class AttachedFileModel extends Serializable {
  @jsonProperty(Number, null) fileId: number | null = null;
  @jsonProperty(FixedTypeModel, null) fixedType: FixedTypeModel | null = null;
  @jsonProperty(String, null) objectGuid: string | null = null;
  @jsonProperty(String, null) descr: string | null = null;
  @jsonProperty(String, null) documentUrl: string | null = null;
  @jsonProperty(String, null) previewUrl: string | null = null;
  @jsonProperty(String) dateInsert: string = '';
  @jsonProperty(String, null) empFioInsert: string | null = null;
  @jsonProperty(String, null) fileSize: string | null = null;
  @jsonProperty(String, null) fileExt: FileExtTypeEnum | null = null;
  @jsonProperty(Boolean) isCanDelete: boolean = false;
}
